import { PlusIcon, ArrowDownIcon, ArrowUpIcon } from '@phosphor-icons/react';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import { ITableHeader, Table } from '../../../../components/table/Table';
import { useSupplier } from '../Supplier/supplierContext';
import { formatDate } from '../../../../utils/date';
import { SUPPLIER_TRUCK_DOCUMENT_MAP } from './constants';
import { LinkButton } from '../../../../components/button/ButtonLink';
import { Button } from 'components/button/Button';
import { moveArrayElement } from '@utils/array';
import { updateSupplierTruckIndexes } from '../../models';

const CONTACT_HEADERS: ITableHeader[] = [
  {
    id: 'licensePlate',
    name: 'Nummerplaat',
  },
  {
    id: 'name',
    name: 'Codenaam',
  },
  {
    id: 'planner',
    name: 'Planner',
  },
  {
    id: 'isActive',
    name: 'Actief',
  },
  {
    id: 'insuranceExpiresAt',
    name: 'Verzekering vervalt op',
  },
  {
    id: 'examinationExpiresAt',
    name: 'Keuring vervalt op',
  },
  {
    id: 'documents',
    name: 'Documenten',
  },
];

export const SupplierTrucksPage = () => {
  const { supplier, refreshData } = useSupplier();
  const [isUpdatingIndexes, setIsUpdatingIndexes] = useState(false);

  const moveTruckIdx = async (truckId: string, offset: number) => {
    const truckIdx = supplier.trucks.findIndex((truck) => truck.id === truckId);
    const trucksCopy = moveArrayElement(supplier.trucks, truckIdx, truckIdx + offset);
    setIsUpdatingIndexes(true);
    try {
      await updateSupplierTruckIndexes(
        supplier.id,
        trucksCopy.map((truck) => truck.id),
        trucksCopy.map((_truck, idx) => idx),
      );
      refreshData();
    } finally {
      setIsUpdatingIndexes(false);
    }
  };

  return (
    <div>
      <div className="flex justify-end mb-4">
        <div className="flex">
          <div>
            <LinkButton to="new" color="primary" iconLeft={<PlusIcon className="button-icon" />}>
              Nieuw trekker
            </LinkButton>
          </div>
        </div>
      </div>
      <Table
        idKey="id"
        headers={CONTACT_HEADERS}
        data={supplier.trucks.sort((a, b) => a.sortIdx - b.sortIdx)}
        mapData={(data) => {
          return [
            <Link to={`${data.id}`} className="link-text">
              {data.licensePlate}
            </Link>,
            data.name,
            data.planner?.name ?? '-',
            data.isActive ? 'Ja' : 'Nee',
            formatDate(data.insuranceExpiresAt),
            formatDate(data.examinationExpiresAt),
            data.documents.map((v) => SUPPLIER_TRUCK_DOCUMENT_MAP[v.type]).join(', '),
            <div className="flex gap-1">
              <Button
                onTrigger={() => {
                  moveTruckIdx(data.id, 1);
                }}
                isLoading={isUpdatingIndexes}
                isDisabled={data.sortIdx === supplier.trucks.length - 1}
              >
                <ArrowDownIcon className="button-icon" />
              </Button>
              <Button
                onTrigger={() => {
                  moveTruckIdx(data.id, -1);
                }}
                isLoading={isUpdatingIndexes}
                isDisabled={data.sortIdx === 0}
              >
                <ArrowUpIcon className="button-icon" />
              </Button>
            </div>,
          ];
        }}
        isMultiSelect
      />
    </div>
  );
};
